import { render, staticRenderFns } from "./multipleSelectionDialog.vue?vue&type=template&id=5b356943&"
import script from "./multipleSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./multipleSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/multipleSelectionDialog.vue"
export default component.exports